(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    /* DELLUMIA mobile collection swipe V5.1 (touch-identifier hardening).
   Images are paired exclusively by the product gallery's normalized Color/Alt
   convention; cards are initialized near the viewport by a shared observer.
   Deliberately does not modify Dazzle's global.js or desktop hover markup. */
(() => {
  const tag = 'dellumia-mobile-card-swipe-v5';
  if (customElements.get(tag)) return;

  const mobile = window.matchMedia('(max-width: 767px), (max-width: 1024px) and (pointer: coarse)');
  const instances = new Set();
  let intersectionObserver = null;
  const imageSizes = '(max-width: 767px) calc((100vw - 36px) / 2), (max-width: 1024px) calc((100vw - 48px) / 2), 340px';
  const normalize = value => String(value || '').trim().toLowerCase().replace(/[_\s]+/g, '-').replace(/-+/g, '-');

  const getObserver = () => {
    if (!('IntersectionObserver' in window)) return null;
    if (!intersectionObserver) {
      intersectionObserver = new IntersectionObserver(entries => {
        if (!mobile.matches) return;
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target._activate();
            if (entry.target._active) intersectionObserver.unobserve(entry.target);
          }
        }
      }, { rootMargin: '450px 0px', threshold: 0 });
    }
    return intersectionObserver;
  };

  const onBreakpointChange = () => {
    for (const component of instances) {
      if (mobile.matches) {
        if (component._active) continue;
        if (getObserver()) intersectionObserver.observe(component);
        else component._activate();
      } else {
        intersectionObserver?.unobserve(component);
        component._suspend();
      }
    }
  };
  if (mobile.addEventListener) mobile.addEventListener('change', onBreakpointChange);
  else mobile.addListener(onBreakpointChange);

  class DellumiaMobileCardSwipeV5 extends HTMLElement {
    connectedCallback() {
      if (this._registered) return;
      this._registered = true;
      instances.add(this);
      this._card = this.closest('.card');
      this._media = this.parentElement;
      this._progress = this._card?.querySelector('.dellumia-mobile-card-progress');
      if (!mobile.matches) return;
      if (getObserver()) intersectionObserver.observe(this);
      else this._activate();
    }

    disconnectedCallback() {
      this._registered = false;
      instances.delete(this);
      intersectionObserver?.unobserve(this);
      this._teardown();
    }

    _parseManifest() {
      if (this._data) return this._data;
      try {
        this._data = JSON.parse(this.querySelector('.dellumia-mobile-card-manifest')?.textContent || '{}');
      } catch (_) {
        this._data = {};
      }
      return this._data;
    }

    _activate() {
      if (this._active || !this.isConnected || !mobile.matches || !this._card || !this._media) return;
      this._active = true;
      this._parseManifest();
      this._onControlClick = event => {
        if (event.target.closest('color-swatch label, variant-hover label, variant-selects label')) this._scheduleSync();
      };
      this._onControlChange = event => {
        if (event.target.matches('input, select')) this._scheduleSync();
      };
      // Capture is important: Dazzle's click-only swatch stops bubbling.
      this._card.addEventListener('click', this._onControlClick, true);
      this._card.addEventListener('change', this._onControlChange, true);
      if ('MutationObserver' in window) {
        this._mediaObserver = new MutationObserver(records => {
          // ColorSwatch.updateMedia prepends the selected .product__media-item.
          if (records.some(record => Array.from(record.addedNodes).some(node =>
            node.nodeType === 1 && node.classList.contains('product__media-item')))) {
            this._scheduleSync();
          }
        });
        this._mediaObserver.observe(this._media, { childList: true });
      }
      // Theme option controls can be replaced asynchronously after an option change.
      // Observe only meaningful chooser changes; ignore slider/image/progress mutations.
      if ('MutationObserver' in window) {
        this._selectorObserver = new MutationObserver(records => {
          const changed = records.some(record => {
            const target = record.target;
            if (target.nodeType === 1 &&
                target.closest('color-swatch, variant-hover, variant-selects, .wb_card_variant')) return true;
            return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(node =>
              node.nodeType === 1 && (node.matches?.('color-swatch, variant-hover, variant-selects, .wb_card_variant') ||
                node.querySelector?.('color-swatch, variant-hover, variant-selects')));
          });
          if (changed) this._scheduleSync();
        });
        this._selectorObserver.observe(this._card, { childList: true, subtree: true });
      }
      if (this._viewport) this._attachViewportListeners(); // Handles reconnection.
      this._scheduleSync();
    }

    _suspend() {
      this.classList.remove('is-ready');
      this._progress?.classList.remove('is-ready');
      this._generation = (this._generation || 0) + 1;
      this._loadingKey = null;
      // Forget only this viewport's active touches when the card is suspended.
      this._touchIds?.clear();
      this._touching = false;
      this._cancelTasks();
      if (!this._active) return;
      this._active = false;
      this._mediaObserver?.disconnect();
      this._mediaObserver = null;
      this._selectorObserver?.disconnect();
      this._selectorObserver = null;
      this._card?.removeEventListener('click', this._onControlClick, true);
      this._card?.removeEventListener('change', this._onControlChange, true);
      this._resizeObserver?.disconnect();
      this._resizeObserver = null;
      this._viewportEvents?.abort();
      this._viewportEvents = null;
    }

    _teardown() {
      this._suspend();
      this._data = null;
      this._key = null;
      this._card = null;
      this._media = null;
      this._progress = null;
    }

    _cancelTasks() {
      clearTimeout(this._fallbackTimer);
      this._fallbackTimer = null;
      if (this._syncRaf) cancelAnimationFrame(this._syncRaf);
      if (this._scrollRaf) cancelAnimationFrame(this._scrollRaf);
      if (this._jumpFrame1) cancelAnimationFrame(this._jumpFrame1);
      if (this._jumpFrame2) cancelAnimationFrame(this._jumpFrame2);
      if (this._settleFrame1) cancelAnimationFrame(this._settleFrame1);
      if (this._settleFrame2) cancelAnimationFrame(this._settleFrame2);
      this._syncRaf = this._scrollRaf = this._jumpFrame1 = this._jumpFrame2 = 0;
      this._settleFrame1 = this._settleFrame2 = 0;
      if (this._jumping && this._viewport && this._savedStyles) {
        this._viewport.style.scrollSnapType = this._savedStyles.snap;
        this._viewport.style.scrollBehavior = this._savedStyles.behavior;
      }
      this._savedStyles = null;
      this._jumping = false;
    }

    _scheduleSync() {
      if (!this._active || !mobile.matches || this._syncRaf) return;
      this._syncRaf = requestAnimationFrame(() => {
        this._syncRaf = 0;
        if (this._active) this._sync();
      });
    }

    _readSelectedOptions() {
      const chooser = this._card.querySelector('color-swatch, variant-hover, variant-selects');
      if (!chooser) return null;
      const names = this._data.optionNames || [];
      if (!names.length) return null;
      // Dazzle renders radio options in fieldsets, but dropdown options in DIVs.
      // Both groups appear in the original Shopify product-option order.
      const groups = Array.from(chooser.querySelectorAll('fieldset, .product-form__input--dropdown'));
      if (groups.length === names.length) {
        return groups.map(group => group.querySelector('input[type="radio"]:checked')?.value ??
          group.querySelector('select')?.value ?? null);
      }
      // Fallback for customized markup: match by option name rather than position.
      return names.map(name => {
        const dropdown = Array.from(chooser.querySelectorAll('select')).find(el =>
          el.getAttribute('name') === `options[${name}]`);
        if (dropdown) return dropdown.value;
        const input = Array.from(chooser.querySelectorAll('input[type="radio"]:checked')).find(el =>
          el.name?.startsWith(`${name}-`) || el.name === `options[${name}]`);
        return input?.value ?? null;
      });
    }

    _selectedColor() {
      const idx = this._data.colorOptionIndex;
      if (idx < 0) return '';
      const values = this._readSelectedOptions();
      if (values) return normalize(values[idx]);
      // Without any picker in the card, use Liquid's initial, valid option.
      return normalize(this.dataset.initialColor);
    }

    _selectedVariantId() {
      const values = this._readSelectedOptions();
      if (!values) return this._data.defaultVariantId ?? null;
      // Never use an arbitrary same-color variant: Size and all other choices
      // must also match in the exact option order, and the variant must exist.
      if (values.some(value => value === null || value === '')) return null;
      const match = (this._data.variants || []).find(variant =>
        variant.options?.length === values.length &&
        values.every((value, index) => value === variant.options[index]));
      return match?.id ?? null;
    }

    _sync() {
      if (!this.isConnected || !mobile.matches) return;
      const data = this._parseManifest();
      if (!Array.isArray(data.images)) return;
      const hasColor = data.colorOptionIndex >= 0;
      const color = hasColor ? this._selectedColor() : '';
      // Same exact Alt / Color rule as snippets/product-media-gallery.liquid.
      const matches = data.images.filter(image => !hasColor || (color && normalize(image.color) === color));
      if (matches.length < 2) {
        this._key = null;
        this._suspendDisplay();
        return;
      }
      const images = matches.slice(0, 2);
      const variant = this._selectedVariantId();
      const key = `${color}:${images[0].id}:${images[1].id}`;
      if (key === this._key) {
        // Update the destination even if the images are still decoding.
        this._updateHrefs(variant);
        // A second click/change or a chooser DOM replacement must not restart
        // an in-flight render for the same two images.
        if (this._loadingKey === key || this.classList.contains('is-ready')) return;
        // A previously failed load may be retried on a subsequent sync.
        this._render(images, variant, key);
        return;
      }
      this._key = key;
      this._render(images, variant, key);
    }

    _suspendDisplay() {
      this._generation = (this._generation || 0) + 1;
      this._loadingKey = null;
      this.classList.remove('is-ready');
      this._progress?.classList.remove('is-ready');
      this._setProgress(0);
    }

    _ensureViewport() {
      if (this._viewport) return;
      const viewport = document.createElement('div');
      viewport.className = 'dellumia-mobile-card-gallery__viewport';
      viewport.setAttribute('role', 'region');
      viewport.setAttribute('aria-label', 'Product photos. Swipe horizontally to view the next photo.');
      const track = document.createElement('div');
      track.className = 'dellumia-mobile-card-gallery__track';
      viewport.appendChild(track);
      this.appendChild(viewport);
      this._viewport = viewport;
      this._track = track;
      this._attachViewportListeners();
    }

    _attachViewportListeners() {
      if (!this._viewport || this._viewportEvents) return;
      const viewport = this._viewport;
      const controller = new AbortController();
      this._viewportEvents = controller;
      const options = { passive: true, signal: controller.signal };
      // Track only fingers that START inside this viewport. event.touches also
      // includes fingers elsewhere on the screen and can leave settling stuck.
      this._touchIds = new Set();
      viewport.addEventListener('touchstart', event => {
        for (const touch of event.changedTouches) this._touchIds.add(touch.identifier);
        this._touching = this._touchIds.size > 0;
      }, options);
      const touchFinished = event => {
        const wasTouching = this._touching;
        for (const touch of event.changedTouches) this._touchIds.delete(touch.identifier);
        this._touching = this._touchIds.size > 0;
        // A finger that started outside the slider must not postpone settling.
        if (wasTouching && !this._touching) this._scheduleSettle();
      };
      viewport.addEventListener('touchend', touchFinished, options);
      viewport.addEventListener('touchcancel', touchFinished, options);
      viewport.addEventListener('scroll', () => {
        if (!this._active || !mobile.matches || this._jumping) return;
        if (!this._scrollRaf) {
          this._scrollRaf = requestAnimationFrame(() => {
            this._scrollRaf = 0;
            if (!this._active || this._jumping || !this._width) return;
            this._setProgress(Math.round(viewport.scrollLeft / this._width) % 2 === 0 ? 1 : 0);
          });
        }
        if (!('onscrollend' in viewport)) this._scheduleSettle();
      }, options);
      if ('onscrollend' in viewport) {
        viewport.addEventListener('scrollend', () => this._settle(), options);
      }
      if ('ResizeObserver' in window) {
        this._resizeObserver = new ResizeObserver(() => {
          if (!this._active || !mobile.matches) return;
          const width = viewport.clientWidth;
          if (!width || width === this._width) return;
          this._width = width;
          if (this.classList.contains('is-ready')) this._jumpTo(this._activeIndex === 1 ? 2 : 1);
        });
        this._resizeObserver.observe(viewport);
      }
    }

    _scheduleSettle() {
      clearTimeout(this._fallbackTimer);
      this._fallbackTimer = setTimeout(() => {
        this._fallbackTimer = null;
        this._settle();
      }, 220);
    }

    _makeSlide(image, clone, variant) {
      const slide = document.createElement('div');
      slide.className = 'dellumia-mobile-card-gallery__slide';
      if (clone) slide.setAttribute('aria-hidden', 'true');
      const link = document.createElement('a');
      link.className = 'dellumia-mobile-card-gallery__link';
      link.href = this._href(variant);
      if (clone) link.tabIndex = -1;
      const picture = document.createElement('img');
      picture.className = 'dellumia-mobile-card-gallery__image';
      picture.alt = clone ? '' : (image.alt || '');
      picture.decoding = 'async';
      picture.loading = 'eager'; // Activated near viewport only; clone URLs repeat the two originals.
      picture.sizes = imageSizes;
      picture.srcset = image.srcset;
      picture.src = image.src;
      picture.width = image.width || 720;
      picture.height = image.height || 720;
      link.appendChild(picture);
      slide.appendChild(link);
      return slide;
    }

    _href(variant) {
      const base = this.dataset.productUrl || '#';
      return variant ? `${base}${base.includes('?') ? '&' : '?'}variant=${encodeURIComponent(variant)}` : base;
    }

    _updateHrefs(variant) {
      const href = this._href(variant);
      this._track?.querySelectorAll('a').forEach(anchor => { if (anchor.getAttribute('href') !== href) anchor.setAttribute('href', href); });
    }

    _render(images, variant, key) {
      this._suspendDisplay();
      this._cancelTasks();
      this._ensureViewport();
      const generation = this._generation;
      this._loadingKey = key;
      // Four slides, not six: [second clone, FIRST, SECOND, first clone].
      // Slot 0 recenters to slot 2; slot 3 recenters to slot 1.
      const slides = [
        this._makeSlide(images[1], true, variant),
        this._makeSlide(images[0], false, variant),
        this._makeSlide(images[1], false, variant),
        this._makeSlide(images[0], true, variant)
      ];
      this._track.replaceChildren(...slides);
      this._width = this._viewport.clientWidth;
      this._activeIndex = 0;
      if (this._width) this._jumpTo(1);
      const decoded = slides.map(slide => {
        const img = slide.querySelector('img');
        if (typeof img.decode === 'function') {
          return img.decode().then(() => img.naturalWidth > 0, () => img.complete && img.naturalWidth > 0);
        }
        if (img.complete) return Promise.resolve(img.naturalWidth > 0);
        return new Promise(resolve => {
          img.addEventListener('load', () => resolve(true), { once: true });
          img.addEventListener('error', () => resolve(false), { once: true });
        });
      });
      Promise.all(decoded).then(results => {
        // A superseded render cannot clear the new render's loading state.
        if (!this.isConnected || !this._active || !mobile.matches ||
            this._generation !== generation || this._key !== key) return;
        // On failure keep the static theme image visible. Another control sync
        // can retry this key without getting stuck in a loading state.
        if (!results.every(Boolean)) {
          this._loadingKey = null;
          return;
        }
        this._jumpTo(1);
        this._setProgress(0);
        // Reveal after restoring snap to avoid a single-frame displacement.
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (!this.isConnected || !this._active || !mobile.matches ||
              this._generation !== generation || this._key !== key) return;
          this.classList.add('is-ready');
          this._progress?.classList.add('is-ready');
          this._loadingKey = null;
        }));
      });
    }

    _setProgress(index) {
      const next = ((index % 2) + 2) % 2;
      if (this._activeIndex === next && this._progress?.dataset.active === String(next)) return;
      this._activeIndex = next;
      if (this._progress) this._progress.dataset.active = String(next);
    }

    _jumpTo(slot) {
      const viewport = this._viewport;
      if (!viewport || !this._width) return;
      if (!this._jumping) {
        this._savedStyles = { snap: viewport.style.scrollSnapType, behavior: viewport.style.scrollBehavior };
      }
      this._jumping = true;
      if (this._jumpFrame1) cancelAnimationFrame(this._jumpFrame1);
      if (this._jumpFrame2) cancelAnimationFrame(this._jumpFrame2);
      viewport.style.scrollSnapType = 'none';
      viewport.style.scrollBehavior = 'auto';
      viewport.scrollLeft = slot * this._width;
      this._jumpFrame1 = requestAnimationFrame(() => {
        this._jumpFrame1 = 0;
        this._jumpFrame2 = requestAnimationFrame(() => {
          this._jumpFrame2 = 0;
          if (!this.isConnected || !this._savedStyles) return;
          viewport.style.scrollSnapType = this._savedStyles.snap;
          viewport.style.scrollBehavior = this._savedStyles.behavior;
          this._savedStyles = null;
          this._jumping = false;
        });
      });
    }

    _settle() {
      if (!this._active || !mobile.matches || this._jumping || this._touching || !this._width ||
          !this.classList.contains('is-ready') || this._settleFrame1 || this._settleFrame2) return;
      // Sample the scroll offset across consecutive frames: an idle timer alone
      // must never jump a partly snapped or still-moving carousel.
      const before = this._viewport.scrollLeft;
      this._settleFrame1 = requestAnimationFrame(() => {
        this._settleFrame1 = 0;
        if (!this._active || this._touching || this._jumping || !mobile.matches) return;
        const during = this._viewport.scrollLeft;
        this._settleFrame2 = requestAnimationFrame(() => {
          this._settleFrame2 = 0;
          if (!this._active || this._touching || this._jumping || !mobile.matches || !this._width) return;
          const after = this._viewport.scrollLeft;
          if (Math.abs(after - during) > 0.5 || Math.abs(during - before) > 0.5) return;
          const slot = Math.round(after / this._width);
          // Absolute pixel tolerance. V3's 8%-of-slide tolerance allowed
          // ~16px premature teleports on a 200px product card.
          if (slot < 0 || slot > 3 || Math.abs(after - slot * this._width) > 1) return;
          this._setProgress(slot % 2 === 0 ? 1 : 0);
          if (slot === 0) this._jumpTo(2);
          else if (slot === 3) this._jumpTo(1);
        });
      });
    }
  }

  customElements.define(tag, DellumiaMobileCardSwipeV5);
})();
  } catch(e) { console.error(e); }
})();

})();
